import {PhoneNumberUtil} from 'google-libphonenumber';
import {parseInt} from 'lodash';

export function formatPhoneNumber(phoneUtil: PhoneNumberUtil, phoneNumberFormat: libphonenumber.PhoneNumberFormat, phoneNumber: string, removeCountryCode: boolean = false, selectedCountryCode?: string): {phoneNumber: string, countryCode: string} {
  if (phoneNumber) {
    try {
      const parsedPhone = phoneUtil.parse(phoneNumber, selectedCountryCode ? phoneUtil.getRegionCodeForCountryCode(parseInt(selectedCountryCode.slice(1), 10)) : undefined);
      const formattedPhone = phoneUtil.format(parsedPhone, phoneNumberFormat);
      const countryCode = selectedCountryCode || ('+' + parsedPhone.getCountryCode());
      if (removeCountryCode && countryCode) {
        const countryCodeRegEx = countryCode.split('').reduce((accumulator, currentLetter) => {
          if (currentLetter === '+') {
            accumulator.push('\\' + currentLetter);
          } else {
            accumulator.push(currentLetter);
          }
          accumulator.push('\\s*');
          return accumulator;
        }, []).join('');
        const withoutCallingCode = formattedPhone.replace(new RegExp(countryCodeRegEx), '');
        return {phoneNumber: withoutCallingCode.trim(), countryCode: countryCode};
      }
      return {phoneNumber: formattedPhone, countryCode: ''};
    } catch (e) {
      return {phoneNumber: phoneNumber, countryCode: ''};
    }
  }
  return {phoneNumber: phoneNumber, countryCode: ''};
}
